const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.attachEvents();
    this.setCartLink();
  }

  attachEvents() {
    this.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.addEventListener(
      'click', (event) => {
        if (event.target.closest('#CartDrawer-Overlay')) {
          this.close();
        }
      }
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    document.body.classList.add('no-scroll');
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('no-scroll');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.querySelector('#CartDrawer');
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response) {
    this.getSectionsToRender().forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
      this.attachEvents();
    });
    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    document.body.classList.add('no-scroll');

    const cartDrawer = this.closest('cart-drawer');
    super.updateQuantity(line, quantity, name).finally(() => {
      cartDrawer?.attachEvents();
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
